import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { Accordion, Card } from "react-bootstrap";
import type { AccordionEventKey } from "react-bootstrap/esm/AccordionContext";
import IconHeader from "./IconHeader";
import IconSubheader from "./IconSubheader";
import classnames from "classnames";
import "./IconInfoCard.scss";

const rotateChevronStyle = {
  transition: "transform 0.3s ease",
};

interface IconInfoCardSection {
  key: string;
  title?: string;
  content?: string;
}

interface IconInfoCardProps {
  title?: string;
  sections: IconInfoCardSection[];
  chevron?: boolean;
}

const IconInfoCard = ({ sections, chevron }: IconInfoCardProps) => {
  const defaultKey = sections.length > 0 ? sections[0].key : null;
  const [activeKey, setActiveKey] = useState<string | null>(defaultKey);

  const handleSelect = (eventKey: AccordionEventKey) => {
    const key = eventKey as string | null;
    setActiveKey(key === activeKey ? null : key);
  };

  return (
    <Accordion
      activeKey={activeKey}
      onSelect={handleSelect}
      className="icon-info-card"
    >
      <Card
        style={{
          border: "none",
          boxShadow: "none",
          padding: 30,
          margin: 0,
          borderRadius: 5,
        }}
      >
        {sections.map((section) => {
          const isOpen = activeKey === section.key;

          return (
            <Accordion.Item
              eventKey={section.key}
              key={section.key}
              style={{ border: "none" }}
            >
              <Card.Header
                style={{
                  padding: 0,
                }}
              >
                <Accordion.Header
                  as="div"
                  style={{
                    padding: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      paddingBottom: isOpen ? "0px" : "15px",
                      width: "100%",
                    }}
                  >
                    <IconHeader
                      variant="infoCardHeader"
                      style={{ color: "#5E6B75" }}
                      headerText={section.title}
                    />
                    {chevron && (
                      <div className={classnames("chevron")}>
                        <FiChevronDown
                          color="white"
                          stroke="#5E6B75"
                          size={16}
                          style={{
                            ...rotateChevronStyle,
                            transform: isOpen
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Accordion.Header>
              </Card.Header>
              <Accordion.Body style={{ margin: 0, padding: 0 }}>
                <IconSubheader
                  subheader={section.content}
                  style={{ fontSize: 14, marginBottom: 0, color: "#5E6B75" }}
                />
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Card>
    </Accordion>
  );
};

export default IconInfoCard;
